import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {/* Video permanece igual */}
            <video width="100%" height="auto" controls>
              <source src="img/about_video.mp4" type="video/mp4" />
              Tu navegador no soporta la etiqueta de video.
            </video>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>¿Quiénes Somos?</h2>
              <ul>
                <li>Venditek responde a la demanda de servicios y productos tecnológicos.</li>
                <li>Dirigimos y supervisamos operaciones minoristas para el crecimiento en comercio automatizado.</li>
                <li>Somos el socio que los minoristas buscan para guiar su evolución hacia la empresa de comercio automatizado más avanzada.</li>
                <li>Venditek actualmente opera en Guatemala y México, con planes de expansión hacia Centroamérica y Sudamérica.</li>
              
              </ul>
              <p>
                
              </p>
              <h3>Nuestros Sistemas Automatizados</h3>
              <p>
                Venditek presenta un sistema automatizado que satisface rápidamente las necesidades del consumidor y genera ingresos para minoristas. 
              </p>
              <p>
                Su diseño innovador permite almacenar productos de diversos tamaños y formas, con un display que muestra el stock y una pantalla táctil de 22" para una experiencia de usuario única.
              </p>
              <p>
                Este diseño moderno permite exhibir hasta 1,300 productos simultáneamente, desde cajas hasta botellas. ¡Versatilidad en cada presentación!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
